module.exports = __webpack_public_path__ + "static/media/service2_3.e60ce6f8.png";